import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-166b9bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-bold mt-x5 mb-x2" }
const _hoisted_2 = {
  key: 0,
  class: "o-text-h6"
}
const _hoisted_3 = {
  key: 1,
  class: "w-100 bg-wild-sand"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex items-center mb-x3 w-full max-w-600" }
const _hoisted_6 = { class: "flex items-center w-full" }
const _hoisted_7 = { class: "flex justify-between o-text-body w-full" }
const _hoisted_8 = { class: "mr-x1" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "text-right o-text-body"
}
const _hoisted_13 = {
  key: 0,
  class: "whitespace-nowrap"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "my-4"
}
const _hoisted_16 = { class: "whitespace-nowrap" }
const _hoisted_17 = {
  key: 2,
  class: "text-11 mt-x2 text-dusty-grey"
}
const _hoisted_18 = { key: 1 }

import useProductAddOns from '@/shared/product/add-ons/useProductAddOns';
import ProductImage from '@/shared/media/ProductImage.vue';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import ProductNetPrice from '@/b2b/product/ui/ProductNetPrice.vue';
import useNetPrices from '@/b2b/product/useNetPrices';
import { computed, watch } from 'vue';
import InputCheckbox from '@/shared/form/InputCheckbox.vue';
import SkeletonLine from '@/shared/spinners/SkeletonLine.vue';
import PDPLink from '@/shared/navigation/PDPLink.vue';
import { ProductDiscountType } from '@/types/productServerApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductAddOns',
  props: {
    sku: {
        type: String,
        required: true,
    },
    numberOfItems: {
        type: Number,
        default: 0,
    },
},
  setup(__props) {

const props = __props



const { addOns, loadingState, labels, maybeFetchAddOns, isRegistered } = useProductAddOns();
const skeletonLines = computed(() => Array.from({ length: props.numberOfItems }, (_, i) => i));
const showLoading = computed(() => loadingState.value === 'loading' && props.numberOfItems > 0);
const { fetchNetPrices } = useNetPrices();

const fetchNetPriceForItems = () => {
    fetchNetPrices(addOns.value.map((addOn) => addOn.sku));
};

const globalLabels = useGlobalLabels(GlobalLabels.product);

watch(addOns, fetchNetPriceForItems, { immediate: true });

const showTitle = computed(() => addOns.value.length > 0);

watch([() => props.sku, isRegistered], () => {
    if (isRegistered.value) {
        maybeFetchAddOns(props.sku);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(showTitle))
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref(labels).addOnsTitle), 1))
        : (_unref(showLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(SkeletonLine, { class: "h-20" })
            ]))
          : _createCommentVNode("", true)
    ]),
    (_unref(loadingState) === 'loaded' || _unref(loadingState) === 'revalidating')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addOns), (addOn) => {
            return (_openBlock(), _createElementBlock("div", {
              key: addOn.sku
            }, [
              _createElementVNode("article", _hoisted_5, [
                _createVNode(InputCheckbox, {
                  modelValue: addOn.selected,
                  "onUpdate:modelValue": ($event: any) => ((addOn.selected) = $event),
                  name: addOn.name,
                  "show-errors": false,
                  class: "h-16 w-16 mr-x3"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "name"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(PDPLink, {
                    sku: addOn.sku,
                    class: "aspect-square flex items-center mr-x3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ProductImage, {
                        class: "w-40 h-40",
                        sku: addOn.sku,
                        "width-on-screen": 1,
                        "aspect-ratio": 1/1,
                        lazy: false,
                        alt: addOn.name,
                        "cache-bust": addOn.imageProperties.version,
                        "hide-press-mode-button": true
                      }, null, 8, ["sku", "alt", "cache-bust"])
                    ]),
                    _: 2
                  }, 1032, ["sku"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(PDPLink, {
                        sku: addOn.sku,
                        class: "c-magic-line"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(addOn.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["sku"]),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(labels).recommendedQuantity) + ": " + _toDisplayString(addOn.recommendedQuantity), 1)
                    ]),
                    _createVNode(_Transition, {
                      name: "o-anim-fade-300",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (addOn.basketState === 'adding')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(labels).addingAddOnToBasket), 1))
                          : (addOn.basketState === 'added')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(labels).addedAddOnToBasket), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", null, "+ " + _toDisplayString(addOn.price.salesPriceTotal.amount), 1),
                                (!addOn.price.discount)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).pricePerUnit, {price: addOn.price.salesPrice.amount})), 1))
                                  : _createCommentVNode("", true),
                                (addOn.price.discount)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      (addOn.price.discount.type === _unref(ProductDiscountType).MyBoliaBoost)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            (_openBlock(), _createElementBlock("span", {
                                              key: addOn.price.discount.percentage,
                                              class: "o-text-caption px-6 py-3 bg-brandy whitespace-nowrap"
                                            }, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).myBoliaDiscount, { discount: addOn.price.discount.percentage })), 1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", null, [
                                        _createTextVNode(_toDisplayString(`${_unref(globalLabels).previousListPrice}:`) + " ", 1),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).pricePerUnit, {price: addOn.price.listPrice.amount})), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(ProductNetPrice, {
                                  "variant-id": addOn.sku,
                                  "is-main-pdp-price": false
                                }, null, 8, ["variant-id"]),
                                (addOn.price.ecoTaxPrice)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(globalLabels).ecoTaxIncluded) + " " + _toDisplayString(addOn.price.ecoTaxPrice.amount), 1))
                                  : _createCommentVNode("", true)
                              ]))
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_unref(showLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(skeletonLines), (item) => {
              return (_openBlock(), _createBlock(SkeletonLine, {
                key: item,
                class: "mb-x3 w-full h-40 sm:max-w-500"
              }))
            }), 128))
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})